export default __webpack_public_path__ + "cfe2aa3843d8cb416e1af3424c3b3d3e.ttf";